class VisualStack {
  private stack: string[] = [];

  push(id: string) {
    this.stack.push(id);
  }

  pop() {
    return this.stack.pop();
  }

  peek() {
    return this.stack[this.stack.length - 1];
  }
}

export default new VisualStack();